import { pick, reduce } from 'lodash';

export const countRem = function () {
    var changeRem = function () {
        document.getElementsByTagName('html')[0].style.fontSize = document.documentElement.clientWidth / 20 + 'px'
    };
    changeRem();
    var t;
    window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(changeRem, 300)
    }, false);
    window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            clearTimeout(t);
            t = setTimeout(changeRem, 300)
        }
    }, false)
};

export const inView = function (el) {
    const rect = pick(el.getBoundingClientRect(), ['top', 'bottom', 'left', 'right', 'width', 'height']);
    const clientHeight = document.documentElement.clientHeight;
    const clientWidth = document.documentElement.clientWidth;
    rect.bottom = clientHeight - rect.bottom;
    rect.right = clientWidth - rect.right;
    if (
        (rect.height + rect.top) > 0 &&
        (rect.height + rect.bottom) > 0 &&
        (rect.width + rect.left > 0) &&
        (rect.width + rect.right > 0)
    ) {
        return true;
    }
    return false;
};

let scrollToInterval = null;
export const scrollTo = function (_target, time = 200) {
    if (scrollToInterval) {
        clearInterval(scrollToInterval);
    }
    // 目标值
    const target = Math.floor(_target);
    // 动画间隔
    const frame = 20;
    // 循环次数
    let number = Math.floor(time / frame);
    // 当前值
    let currentValue = document.documentElement.scrollTop || document.body.scrollTop;
    // 每次移动值
    const eachValue = Math.floor((target - currentValue) / number);
    const interval = scrollToInterval = setInterval(() => {
        if (!number) {
            clearInterval(interval);
            return;
        }
        if (number === 1) {
            document.documentElement.scrollTop = document.body.scrollTop = target;
        } else {
            document.documentElement.scrollTop = document.body.scrollTop = currentValue += eachValue;
        }
        number--;
    }, frame);
};

export const getLocationSearch = function () {
    let search = location.search;
    if (!search) {
        return {};
    }
    search = search.slice(1);
    const searchArr = search.split('&');
    return reduce(searchArr, (result, query) => {
        const queryArr = query.split('=');
        if (queryArr[0]) {
            result[queryArr[0]] = queryArr[1] || '';
            if (result[queryArr[0]] === 'undefined') {
                result[queryArr[0]] = '';
            }
            // 下方代码为处理url内testId上报被刷问题，只通过test值来判断，不再取testId
            if (queryArr[0] === 'test' && result[queryArr[0]] === '20022601') {
                result['testIdInuse'] = '1';
            }
            // if (queryArr[0] === 'testId') {
            //     result[queryArr[0]] = '';
            // }
        }
        return result;
    }, {});
};

export const isAutohomeApp = () => {
    return /auto_android|auto_iphone|autohomeapp/.test(navigator.userAgent);
};

const isMobile = /(android|bb\d+|meego).+mobile|android|playbook|silk|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4));

export const getOS = () => {
    // os: android:2, ios:1, other:3
    if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
        return 1;
    }
    if (/android/i.test(navigator.userAgent)) {
        return 2;
    }
    return 3;
};

// PC: 1,  M: 2, APP: 3
export const getPlatform = () => {
    return isAutohomeApp() ? 3 : isMobile ? 2 : 1;
};

export const getCookie = (name, defaultValue) => {
    var value;
    var cookie = document.cookie;
    var start = cookie.indexOf(name + '=');
    var end;
    if (start !== -1) {
        start += name.length + 1;
        end = cookie.indexOf(';', start);
        if (end === -1) {
            end = cookie.length;
        }
        value = decodeURIComponent(cookie.substring(start, end) || '');
    }
    return value || defaultValue || '';
};
export const setCookie = (name, value, expires, domain) => {
    var sCookie = name + '=' + encodeURIComponent(value);
    if (expires) {
        var exp = new Date(new Date().getTime() + expires);
        sCookie += '; expires=' + exp.toGMTString();
    }
    if (domain) {
        sCookie += '; domain=.' + domain;
    }
    sCookie += '; path=/';
    document.cookie = sCookie;
};
export const queryToString = (query, encode) => {
    var obj = query || {};
    var items = [];
    var k;
    var v;
    for (k in obj) {
        if (obj.hasOwnProperty(k)) {
            if (typeof obj[k] === 'object') {
                var tempVal = JSON.stringify(obj[k]);
                v = encode ? encodeURIComponent(tempVal) : tempVal;
            } else {
                v = encode ? encodeURIComponent(obj[k]) : obj[k];
            }
            items.push(k + '=' + v);
        }
    }
    return items.join('&');
};

export const appendQuery = (url, query) => {
    var splitAry = url.split('#');
    var urlHast = splitAry[1] ? '#' + splitAry[1] : '';
    url = splitAry[0];
    var hasQuery = (/\?/g).test(url);
    url += (hasQuery ? '&' : '?') + query + urlHast;
    return url;
};

const composedPath = element => {
    let el = element;
    const path = [];
    while (el) {
        path.push(el);
        if (el === document) {
            path.push(window);
            return path;
        }
        el = el.parentNode;
    }
};
export const getEventPath = e => {
    return e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
};

/**
 * 生成全局唯一GUID
 * @returns {string}
 */
export const uuid = () => {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}

export const disableIOSScroll = () => {
    let startY, endY;
    document.documentElement.addEventListener('touchstart', e => {
        startY = e.touches[0].pageY;
    }, { passive: true });
    document.documentElement.addEventListener('touchmove', e => {
        const scrollTop = document.documentElement.scrollTop;
        const clientHeight = document.documentElement.clientHeight;
        const offsetHeight = document.documentElement.offsetHeight;
        endY = e.touches[0].pageY;
        if (endY > startY && scrollTop <= 0) {
            e.preventDefault();
        }

        if (endY < startY && (scrollTop + clientHeight) >= offsetHeight) {
            e.preventDefault();
        }
    }, { passive: true });
};

export function loadSessionGetter() {
    // 加载大数据js，种sessionid的cookie
    var date = new Date();
    var locationSearch = getLocationSearch();
    var timestamp = '' + date.getFullYear() + (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1) + (date.getDate() < 9 ? '0' : '') + (date.getDate());
    var headSrc = '//x.autoimg.cn/bi/mda/ahas_head.min.js?v=' + timestamp,
        headScript = document.createElement('script'),
        bodySrc = '//x.autoimg.cn/bi/mda/ahas_body.min.js?v=' + timestamp,
        bodyScript = document.createElement('script'),
        dom__head = document.querySelector('head');
    dom__head.appendChild(headScript);
    headScript.src = headSrc;
    window.pvTrack = {};
    pvTrack.site = 1211079;
    pvTrack.category = 912;
    pvTrack.subcategory = 16530;
    pvTrack.seriesid = locationSearch.seriesId;
    pvTrack.specid = locationSearch.specId;
    headScript.onload = function () {
        document.querySelector('body').appendChild(bodyScript);
        bodyScript.src = bodySrc;
    }
};
/**
 * 获取url中参数
 * @param {String} name 参数名
 * @param {Number} type 获取参数类型，0是正常query，1是path中带下划线格式的参数
 */
export function getQueryString(name, type) {
    var result = '';
    if (!type || type === 0) {
        var loc = window.location.search.substr(1);
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        var r = loc.match(reg);
        if (r !== null) {
            result = decodeURI(r[2]);
        }
    } else {
        var arr = location.href.split('/');
        arr.forEach(function (item) {
            if (item.indexOf(name) === 0) {
                result = item.slice(name.length + 1);
            }
        })
    }
    return result;
}

export function leftpad(str, len, ch = ' ') {
    str = str + '';
    len = len - str.length;
    if (len <= 0) {
        return str;
    }
    ch = ch + '';
    let pad = '';
    while (len) {
        if (len & 1) {
            pad += ch;
        }
        len >>= 1;
        ch += ch;
    }
    return pad + str;
}

/**
 * 获取日期格式输出
 * @param  {Date}   time   时间
 * @param  {String} format 输出格式，要求必须含有yyyy,mm,dd
 * @return {String}        默认返回yyyymmdd格式时间
 */
export function getTimeStr(time, format = 'yyyy-MM-dd') {
    if (!time) {
        return '';
    }
    if (typeof time === 'string' ||
        typeof time === 'number') {
        time = new Date(time);
    }
    return format
        .replace('yyyy', time.getFullYear())
        .replace('MM', leftpad(time.getMonth() + 1, 2, '0'))
        .replace('dd', leftpad(time.getDate(), 2, '0'))
        .replace('HH', leftpad(time.getHours(), 2, '0'))
        .replace('mm', leftpad(time.getMinutes(), 2, '0'))
        .replace('ss', leftpad(time.getSeconds(), 2, '0'));
}


